import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import React from "react";

export default function Pausaly({ selectedCollectionPoint }) {
  const pausaly = selectedCollectionPoint.pausaly || [];

  return (
    <>
      {pausaly.length > 0 ? (
        <Box sx={{ mt: 4 }}>
          {pausaly.map((pausal) => (
            <Accordion key={pausal.idZsml1} disableGutters>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", pr: 2 }}>
                  <Typography>{pausal.nazev}</Typography>
                  <Typography>{pausal.mnozstvi} m³</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {pausal.parametry && pausal.parametry.length > 0 ? (
                  <TableContainer>
                    <Table size="small" aria-label="Parametry paušálu">
                      <TableHead>
                        <TableRow>
                          <TableCell>Kód sazby</TableCell>
                          <TableCell>Název sazby</TableCell>
                          <TableCell align="right">Sazba</TableCell>
                          <TableCell align="right">Počet</TableCell>
                          <TableCell align="right">Měsíce</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pausal.parametry.map((parametr) => (
                          <TableRow key={parametr.id}>
                            <TableCell>{parametr.kodSazby ?? "—"}</TableCell>
                            <TableCell>{parametr.nazevSazby || "—"}</TableCell>
                            <TableCell align="right">{parametr.sazba ?? "—"}</TableCell>
                            <TableCell align="right">{parametr.pocet ?? "—"}</TableCell>
                            <TableCell align="right">{parametr.pocMes ?? "—"}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography variant="body2">
                    Detailní parametry nenalezeny.
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" sx={{ mt: 2 }}>
          Nebyly nalezeny žádné záznamy.
        </Typography>
      )}
    </>
  );
}
